import client from '../httpClient';

const librarydirResisterApi = (params) => {
  return client.post('/library-directories/', JSON.stringify(params), { isShowLoading: false });
};

export default librarydirResisterApi;
